// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"b5d8ec32","42":"cafa66c4","193":"a4cbb0d1","517":"68c82405","690":"552557ce","787":"0be77680","837":"b16f7500","843":"28b0f7de"}[chunkId] + ".chunk.js";
};